import { Dropdown, Menu, Space } from 'antd';
import { DropdownIcon } from 'svgIcon';

const ECECategoryComponent = ({
    categoryList,
    setCatClick,
    catClick,
    showSideCategories,
    setNewOne,
}: any) => {
    const getMenu = (categoryList: any) => (
        <Menu>
            {categoryList.map((item: any) => (
                <Menu.Item key={item.category_id} onClick={() => { setCatClick(item); setNewOne(1); }}>
                    <p>{item.category_name}</p>
                </Menu.Item>
            ))}
        </Menu>
    );
    return (
        <>
            <p className="pText">Sort by</p>
            <div>
                {categoryList && categoryList.length > 0 && (
                    <Dropdown overlay={getMenu(categoryList)} className="dropDown">
                        <Space className="subInnerHeading">{catClick && catClick.category_name} <DropdownIcon /></Space>
                    </Dropdown>
                )}
            </div>
        </>
    )
}

export default ECECategoryComponent